// cogido de https://github.com/marmelab/react-admin examples/demo/src/layout/ de version 3.0.1 
//  (es el menu de https://marmelab.com/react-admin-demo/)
// añadido permissions segun https://marmelab.com/react-admin/Authorization.html
// cambiado apertura para que solo haya uno abierto, y creado menuDefs

import PropTypes from 'prop-types';

const Menu = function () {
  return null;
};

Menu.propTypes = {
  onMenuClick: PropTypes.func,
  logout: PropTypes.object,
};

export default Menu;
